export default "__VITE_ASSET__BUaS_uzb__"